import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';

@Component({
  selector: 'app-body',
  standalone: true,
  imports: [
    CommonNgModule
  ],
  templateUrl: './body.component.html',
  styleUrl: './body.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class BodyComponent {
  
  @Input() Theme: any;
  
  constructor() { }

  ngOnInit() {
  }
}
